import { cloneDeep, first, isEmpty, last, tail } from 'lodash'
import { getType } from 'typesafe-actions'

import { FlashNoticeAction, hideFlashNoticeBegin, hideFlashNoticeEnd, showFlashNotice } from './actions'
import { FlashNoticeState } from './types'

export const flashNoticeReducer = function (flashContentQueue: FlashNoticeState = [], action: FlashNoticeAction) {
  switch (action.type) {
    case getType(showFlashNotice): {
      let newContentQueue = cloneDeep(flashContentQueue)
      if (!isEmpty(newContentQueue)) {
        // TODO: we have to clean the queue from elements in the front with open = false.
        // This shouldn't be required. Fix it.
        while (!first(newContentQueue)!.show) {
          newContentQueue = newContentQueue.slice(1)
        }
        last(newContentQueue)!.show = false
      }
      newContentQueue.push(action.payload)
      return newContentQueue
    }
    case getType(hideFlashNoticeBegin): {
      const newContentQueue = cloneDeep(flashContentQueue)
      const firstFlash = first(newContentQueue)
      if (firstFlash) {
        firstFlash.show = false
      }
      return newContentQueue
    }
    case getType(hideFlashNoticeEnd):
      return tail(flashContentQueue)
    default:
      return flashContentQueue
  }
}
